module.exports = ".row {\n  margin-bottom: 20px;\n  overflow: hidden; }\n\n.row > div {\n  padding: 0px;\n  border: 2px solid rgba(0, 0, 0, 0.125);\n  border-top: 0;\n  border-left: 0;\n  right: -3px;\n  bottom: -3px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/products/product-list/product-list.component.scss
// module id = ./src/app/components/products/product-list/product-list.component.scss
// module chunks = main